import { clientFetch } from "@/lib/api/client-fetch";
import type { Folder } from "@/lib/supabase";

export async function fetchFolders(
  workspaceId?: string | null,
): Promise<Folder[]> {
  const qs = new URLSearchParams();
  if (workspaceId) qs.set("workspace_id", workspaceId);
  const res = await clientFetch(`/api/folders?${qs.toString()}`);
  if (!res.ok) throw new Error("Failed to fetch folders");
  const payload = await res.json();
  return payload.data as Folder[];
}
